import Home from "../pages/Home";
import About from "../pages/About";
import Trainer from "../pages/Trainer";
import TrainsessionCreate from "../pages/TrainsessionCreate";
import Changepassword from "../pages/Changepassword";
import Reinhardbonnke from "../pages/Reinhardbonnke";
import Termsandconditions from "../pages/Termsandconditions";
import Privacypolice from "../pages/Privacypolice";
import Requesttriner from "../pages/Requesttriner";
import RequesttrinerOne from "../pages/RequesttrinerOne";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/trainer",
    element: <Trainer />,
  },
   {
    path: "/createtrainter",
    element: <TrainsessionCreate />,
  },
    {
    path: "/changepassword",
    element: <Changepassword />,
  },
  {
    path: "/member/:id",
    element: <Reinhardbonnke />,
  },
  {
    path: "/termsandconditions",
    element: <Termsandconditions />,
  },
  {
    path: "/privacypolice",
    element: <Privacypolice />,
  },
    {
    path: "/requesttraining",
    element: <Requesttriner />,
  },
   {
    path: "/requesttraining_one",
    element: <RequesttrinerOne />,
  },
];

export default routes;